/* RESPONSIBLE TEAM: team-reporting */
import { tracked } from '@glimmer/tracking';

export default class ReportMode {
  @tracked isEditMode;
  @tracked isSidePanelOpen;
  @tracked isShareSideDrawerOpen;
  @tracked isShareExternallySideDrawerOpen: boolean;
  @tracked isReportNew;

  constructor(
    isEditMode: boolean,
    isSidePanelOpen: boolean,
    isShareSideDrawerOpen: boolean,
    isReportNew: boolean,
    isShareExternallySideDrawerOpen = false,
  ) {
    this.isEditMode = isEditMode;
    this.isSidePanelOpen = isSidePanelOpen;
    this.isShareSideDrawerOpen = isShareSideDrawerOpen;
    this.isShareExternallySideDrawerOpen = isShareExternallySideDrawerOpen;
    this.isReportNew = isReportNew;
  }
}
